import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { reload } from 'axios/reportApi';
import useApi from 'hooks/useApi';
import { Trans } from 'react-i18next';
import { useReportWorkplaceState } from './Reports';

type ReportReloadButtonProps = {
    id: number;
};

export default function ReportReloadButton({ id }: ReportReloadButtonProps) {
    const { fetchQuery } = useReportWorkplaceState();
    const api = useApi();

    return (
        <div
            className="workplace-action-btn cursor--pointer"
            onClick={async () => {
                await reload(api, id);
                fetchQuery.refetch();
            }}
        >
            <FontAwesomeIcon icon={faRefresh} className="text-success workplace-action-btn__icon" />
            <span>
                <Trans i18nKey="BackOfficeReloadReport" />
            </span>
        </div>
    );
}
